// src/redux/services/historyApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:7600/api',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth?.token || localStorage.getItem('token');
    if (token) headers.set('x-auth-token', token);
    return headers;
  },
});

export const historyApi = createApi({
  reducerPath: 'historyApi',
  baseQuery,
  tagTypes: ['History'],
  endpoints: (builder) => ({

    // 📅 Get available dates for calendar
    getHistoryDates: builder.query({
      query: (deviceId) => `/history/${deviceId}/dates`,
      transformResponse: (res) => res || {},
      providesTags: ['History'],
    }),

    // 🎬 Playback data (route points)
    getPlaybackData: builder.query({
      query: ({ deviceId, date, startDate, endDate }) => {
        if (date) {
          return `/history/${deviceId}/playback?date=${date}`;
        }
        if (startDate && endDate) {
          return `/history/${deviceId}/playback?startDate=${startDate}&endDate=${endDate}`;
        }
        return `/history/${deviceId}/playback`;
      },
      transformResponse: (res) => res || {},
      providesTags: ['History'],
    }),

    // 📊 Daily summary
    getDailySummary: builder.query({
      query: ({ deviceId, date }) =>
        `/history/${deviceId}/summary?date=${date}`,
      transformResponse: (res) => res || {},
      providesTags: ['History'],
    }),

    // 🅿️ Stoppages / parking
    getStoppages: builder.query({
      query: ({ deviceId, date, startDate, endDate }) => {
        if (date) {
          return `/history/${deviceId}/stoppages?date=${date}`;
        }
        if (startDate && endDate) {
          return `/history/${deviceId}/stoppages?startDate=${startDate}&endDate=${endDate}`;
        }
        return `/history/${deviceId}/stoppages`;
      },
      transformResponse: (res) => res || {},
      providesTags: ['History'],
    }),

    // 📋 Trip report
    getTripReport: builder.query({
      query: ({ deviceId, startDate, endDate }) =>
        `/history/${deviceId}/report?startDate=${startDate}&endDate=${endDate}`,
      transformResponse: (res) => res || {},
      providesTags: ['History'],
    }),

  }),
});

export const {
  useGetHistoryDatesQuery,
  useGetPlaybackDataQuery,
  useGetDailySummaryQuery,
  useGetStoppagesQuery,
  useGetTripReportQuery,
} = historyApi;
